import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";

export const getServicesAPI = async (os, type, searchValue) => {
  const data = await phpRequest.post("/service-management/datatable", {
    os: os ? os.name : null,
    type: type ? type.name : null,
    keyword: searchValue,
  });
  await localforage.setItem("services", data.services);
  return data.services;
};
